export default "__VITE_ASSET__DWKGnNmR__"